'use client';
// import { globalHistory } from '@reach/router';
import React, { useEffect, useRef, useState } from 'react';

import { useOnClickOutside } from '../../../hooks';
import { IChinaPageHome } from '../../../lib/fragments/chinaPageHome';
import { ILibraryMenuGroup } from '../../../lib/fragments/libraryMenuGroup';
import { ITextAndImageCardBlock } from '../../../lib/fragments/textAndImageCardBlock';
import ImageWrapper from '../../image-wrapper/Image-wrapper';
import LinkWrapper from '../../link-wrapper/link-wrapper';
import { ChinaFoldOutMenu } from '../china-fold-out-menu/china-fold-out-menu';
import { usePathname } from 'next/navigation';

interface ChinaHeaderProps {
  meetingPlace?: IChinaPageHome;
  menuItems: ILibraryMenuGroup[];
  menuCards: ITextAndImageCardBlock[];
}
export const ChinaHeader = ({
  meetingPlace,
  menuCards,
  menuItems,
}: ChinaHeaderProps) => {
  const [showMenu, setShowMenu] = useState(false);
  const pathname = usePathname();
  const ref = useRef(null);
  useOnClickOutside(ref, () => setShowMenu(false));

  useEffect(() => {
    showMenu
      ? document.body.classList.add('backdrop')
      : document.body.classList.remove('backdrop');
  }, [showMenu]);

  const toggleMenu = () => setShowMenu(!showMenu);

  // Following effect hides the menu when user clicks something in it. Before the menu wasnt closed if you clicked a link/card pointing to the same page you are on.
  // useEffect(() => {
  //   if (showMenu === false) return;
  //   return globalHistory.listen(({ action }) => {
  //     if (action === 'PUSH') setShowMenu(false);
  //   });
  // }, [showMenu]);

  useEffect(() => {
    if (showMenu === false) return;

    // Close menu when pathname changes
    setShowMenu(false);
  }, [pathname]);

  return (
    <header className="z-10 flex h-24 flex-row items-center justify-between px-5 lg:h-28 lg:px-0">
      {meetingPlace?.logo && (
        <LinkWrapper
          data={`/${meetingPlace.sys.locale?.toLowerCase()}`}
          itemProp="item"
        >
          <ImageWrapper
            className="max-h-10 w-36"
            alt={''}
            url={meetingPlace?.logo?.url}
            height={
              meetingPlace?.logo?.height
                ? parseInt(meetingPlace?.logo?.height)
                : 60
            }
            width={144}
            imgClassName="max-h-10 !w-auto"
          />
        </LinkWrapper>
      )}
      <div className="hidden flex-1 text-end text-bodym lg:block">
        {menuItems[0].pagesCollection?.items
          ?.filter(Boolean)
          ?.map((link, index) => (
            <LinkWrapper
              data={link}
              key={`${link.name}-${index}`}
              className="pr-4"
            >
              {link.name}
            </LinkWrapper>
          ))}
      </div>
      <nav>
        <button
          onClick={toggleMenu}
          type="button"
          className="flex flex-row items-center justify-between rounded-full bg-brand-yellow-1 lg:hover:bg-accent-primary-dark focus:bg-accent-primary-dark focus-visible:outline focus-visible:outline-4 focus-visible:outline-offset-4 focus-visible:outline-brand-grey-2 active:bg-accent-primary-dark lg:transition-all"
          aria-expanded={showMenu}
          aria-controls="main-menu"
          aria-label="Open main menu"
        >
          <div className="box-content grid h-16 w-full place-items-center content-center pl-2 text-bodym">
            {menuItems[1].title}
          </div>
          <div className="box-content grid h-15 w-15 place-items-center content-center pr-2">
            <span className="m-px h-1 w-5 rounded-sm bg-brand-grey-3 lg:bg-brand-grey-4"></span>
            <span className="m-px h-1 w-5 rounded-sm bg-brand-grey-3 lg:bg-brand-grey-4"></span>
            <span className="m-px h-1 w-5 rounded-sm bg-brand-grey-3 lg:bg-brand-grey-4"></span>
          </div>
        </button>
        <ChinaFoldOutMenu
          el={ref}
          menuClass={`${
            showMenu
              ? ''
              : 'translate-y-[calc(100%+10rem)] lg:translate-y-0 lg:hidden'
          }`}
          toggleMenu={toggleMenu}
          logo={meetingPlace?.logo}
          menuGroups={menuItems}
          menuCards={menuCards}
        />
      </nav>
    </header>
  );
};
